// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Orbitron:wght@600;800;900&family=Poppins:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --lp-orange    : #ff6a00;
  --lp-orange2   : #ff9533;
  --lp-orange-gl : rgba(255, 106, 0, 0.30);
  --lp-blue      : #0047cc;
  --lp-blue2     : #002b88;
  --lp-white     : #ffffff;
  --lp-bg        : #f8faff;
  --lp-border    : #dde4f7;
  --lp-text      : #0d1b3e;
  --lp-muted     : #6b7280;
  --lp-err       : #ef4444;
  --lp-r         : 13px;
}

/* ══ ROOT ══ */
.zuppa_lms_login_pg_root {
  display        : flex;
  width          : 100%;
  font-family    : 'Poppins', sans-serif;
  overflow       : hidden;
  background     : var(--lp-bg);
  animation      : lp_root_in 0.4s ease both;
}
@keyframes lp_root_in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ════════════════════════════════════
   LEFT PANEL
════════════════════════════════════ */
.zuppa_lms_login_pg_panel {
  position        : relative;
  width           : 44%;
  display         : flex;
  align-items     : center;
  justify-content : center;
  overflow        : hidden;
  background      : linear-gradient(150deg,
    var(--lp-blue2) 0%,
    var(--lp-blue)  55%,
    #1a3fa8         78%,
    var(--lp-orange) 130%
  );
  animation : lp_panel_slide 0.75s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes lp_panel_slide {
  from { transform: translateX(-100%); }
  to   { transform: translateX(0);     }
}

/* Bubbles */
.zuppa_lms_login_pg_bubble {
  position      : absolute;
  border-radius : 50%;
  pointer-events: none;
}
.zuppa_lms_login_pg_bubble_1 {
  width: 360px; height: 360px;
  top: -90px; left: -90px;
  background: rgba(255,255,255,0.06);
  animation: lp_bubble 7s ease-in-out infinite;
}
.zuppa_lms_login_pg_bubble_2 {
  width: 220px; height: 220px;
  bottom: 40px; right: -50px;
  background: rgba(255,106,0,0.14);
  animation: lp_bubble 9s ease-in-out 2s infinite;
}
.zuppa_lms_login_pg_bubble_3 {
  width: 120px; height: 120px;
  bottom: 200px; left: 30px;
  background: rgba(255,255,255,0.05);
  animation: lp_bubble 6s ease-in-out 1s infinite;
}
@keyframes lp_bubble {
  0%,100% { transform: scale(1);    opacity: 0.7; }
  50%     { transform: scale(1.15); opacity: 1;   }
}

/* Panel body */
.zuppa_lms_login_pg_panel_body {
  position        : relative;
  z-index         : 2;
  display         : flex;
  flex-direction  : column;
  align-items     : center;
  gap             : 16px;
  padding         : 40px 28px;
  text-align      : center;
  animation       : lp_body_in 0.6s ease 0.65s both;
}
@keyframes lp_body_in {
  from { opacity: 0; transform: translateY(22px); }
  to   { opacity: 1; transform: translateY(0);    }
}

/* Drone */
.zuppa_lms_login_pg_drone_wrap {
  display        : flex;
  flex-direction : column;
  align-items    : center;
}
.zuppa_lms_login_pg_drone_img {
  width          : min(62%, 240px);
  height         : auto;
  object-fit     : contain;
  filter         : drop-shadow(0 18px 40px rgba(0,0,0,0.45));
  animation      : lp_drone 3.8s ease-in-out infinite;
}
@keyframes lp_drone {
  0%,100% { transform: translateY(0)     rotate(-1.5deg); }
  50%     { transform: translateY(-18px) rotate(1.5deg);  }
}
.zuppa_lms_login_pg_drone_shadow {
  width         : 80px;
  height        : 14px;
  background    : radial-gradient(ellipse, rgba(0,0,0,0.3) 0%, transparent 70%);
  border-radius : 50%;
  margin-top    : -2px;
  animation     : lp_shadow 3.8s ease-in-out infinite;
}
@keyframes lp_shadow {
  0%,100% { transform: scaleX(1);    opacity: 0.55; }
  50%     { transform: scaleX(0.5);  opacity: 0.2;  }
}

.zuppa_lms_login_pg_panel_title {
  font-family   : 'Orbitron', sans-serif;
  font-size     : clamp(1.3rem, 2.5vw, 2rem);
  font-weight   : 900;
  color         : var(--lp-white);
  margin        : 0;
  letter-spacing: 0.05em;
  text-shadow   : 0 2px 18px rgba(0,0,0,0.3);
}
.zuppa_lms_login_pg_panel_sub {
  font-size  : clamp(0.75rem, 1.2vw, 0.88rem);
  color      : rgba(255,255,255,0.84);
  line-height: 1.7;
  margin     : -4px 0 0;
  max-width  : 220px;
}

/* Dots */
.zuppa_lms_login_pg_dots {
  display    : flex;
  gap        : 9px;
  margin-top : 4px;
}
.zuppa_lms_login_pg_dots span {
  width         : 9px;
  height        : 9px;
  border-radius : 50%;
  background    : rgba(255,255,255,0.35);
  animation     : lp_dot 1.5s ease-in-out infinite;
}
.zuppa_lms_login_pg_dots span:nth-child(2) { animation-delay: 0.22s; }
.zuppa_lms_login_pg_dots span:nth-child(3) { animation-delay: 0.44s; }
@keyframes lp_dot {
  0%,80%,100% { background: rgba(255,255,255,0.3); transform: scale(1);   }
  40%         { background: var(--lp-orange);       transform: scale(1.4); }
}

/* ════════════════════════════════════
   RIGHT — FORM SIDE
════════════════════════════════════ */
.zuppa_lms_login_pg_form_side {
  flex            : 1 1;
  display         : flex;
  align-items     : center;
  justify-content : center;
  padding         : 40px 36px;
  background      : var(--lp-white);
  animation       : lp_form_slide 0.75s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes lp_form_slide {
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

.zuppa_lms_login_pg_form {
  width          : 100%;
  max-width      : 400px;
  display        : flex;
  flex-direction : column;
  align-items    : center;
  gap            : 18px;
  animation      : lp_body_in 0.55s ease 0.7s both;
}

/* Logo */
.zuppa_lms_login_pg_logo {
  width      : 84px;
  height     : auto;
  object-fit : contain;
  filter     : drop-shadow(0 4px 14px rgba(255,106,0,0.22));
}

/* Title */
.zuppa_lms_login_pg_form_title {
  font-family    : 'Orbitron', sans-serif;
  font-size      : clamp(1.3rem, 2.5vw, 1.75rem);
  font-weight    : 800;
  color          : var(--lp-blue);
  margin         : 0;
  text-align     : center;
  letter-spacing : 0.02em;
}
.zuppa_lms_login_pg_form_title span {
  color: var(--lp-orange);
}

/* Sub */
.zuppa_lms_login_pg_form_sub {
  font-size   : 0.82rem;
  color       : var(--lp-muted);
  margin      : -10px 0 4px;
  text-align  : center;
}

/* ── Field wrapper ── */
.zuppa_lms_login_pg_field {
  width          : 100%;
  display        : flex;
  flex-direction : column;
  gap            : 0;
}

/* Input + icon row */
.zuppa_lms_login_pg_input_wrap {
  position        : relative;
  width           : 100%;
  display         : flex;
  align-items     : center;
}

/* Left icon */
.zuppa_lms_login_pg_field_icon {
  position        : absolute;
  left            : 14px;
  top             : 40%;
  transform       : translateY(-50%);
  display         : flex;
  align-items     : center;
  justify-content : center;
  pointer-events  : none;
  z-index         : 3;
  line-height     : 1;
}

/* Input */
.zuppa_lms_login_pg_input {
  width          : 100%;
  padding        : 14px 50px 10px 46px;
  border         : 1.8px solid var(--lp-border);
  border-radius  : var(--lp-r);
  font-size      : 0.9rem;
  font-family    : 'Poppins', sans-serif;
  color          : var(--lp-text);
  background     : #f7f9ff;
  outline        : none;
  box-sizing     : border-box;
  transition     : border-color 0.25s, box-shadow 0.25s, background 0.25s;
}
.zuppa_lms_login_pg_input::placeholder {
  color: #aab4cc;

}
.zuppa_lms_login_pg_input:focus {
  border-color : var(--lp-orange);
  background   : #fff;
  
  box-shadow   : 0 0 0 3.5px rgba(255,106,0,0.13);
}
.zuppa_lms_login_pg_input_bad {
  border-color : var(--lp-err) !important;
  box-shadow   : 0 0 0 3px rgba(239,68,68,0.1) !important;
}

/* Eye button — right side */
.zuppa_lms_login_pg_eye {
  position        : absolute;
  right           : 13px;
  top             : 50%;
  transform       : translateY(-50%);
  background      : none;
  border          : none;
  cursor          : pointer;
  display         : flex;
  align-items     : center;
  justify-content : center;
  padding         : 0;
  z-index         : 3;
  line-height     : 1;
  transition      : transform 0.2s, opacity 0.2s;
}
.zuppa_lms_login_pg_eye:hover {
  transform : translateY(-50%) scale(1.2);
  opacity   : 0.8;
}

/* Error message */
.zuppa_lms_login_pg_err {
  font-size   : 0.72rem;
  color       : var(--lp-err);
  padding-left: 4px;
  margin      : 5px 0 0;
}

/* Forgot */
.zuppa_lms_login_pg_forgot {
  align-self      : flex-end;
  font-size       : 0.78rem;
  color           : var(--lp-blue);
  cursor          : pointer;
  text-decoration : underline;
  font-weight     : 600;
  margin-top      : -4px;
  transition      : color 0.2s;
}
.zuppa_lms_login_pg_forgot:hover { color: var(--lp-orange); }

/* Login button */
.zuppa_lms_login_pg_btn {
  width           : 100%;
  padding         : 14px;
  margin-top      : 4px;
  border          : none;
  border-radius   : var(--lp-r);
  background      : linear-gradient(120deg, var(--lp-orange) 0%, var(--lp-orange2) 100%);
  color           : #fff;
  font-family     : 'Orbitron', sans-serif;
  font-size       : 0.95rem;
  font-weight     : 700;
  letter-spacing  : 0.1em;
  cursor          : pointer;
  display         : flex;
  align-items     : center;
  justify-content : center;
  gap             : 10px;
  box-shadow      : 0 7px 22px var(--lp-orange-gl);
  transition      : transform 0.2s, box-shadow 0.2s, filter 0.2s;
}
.zuppa_lms_login_pg_btn:hover {
  transform  : translateY(-2px);
  box-shadow : 0 12px 32px var(--lp-orange-gl);
  filter     : brightness(1.07);
}
.zuppa_lms_login_pg_btn:active {
  transform: translateY(0);
}

/* ════════════════════════════════════
   RESPONSIVE — Tablet ≤ 860px
════════════════════════════════════ */
@media (max-width: 860px) {
  .zuppa_lms_login_pg_panel       { width: 42%; }
  .zuppa_lms_login_pg_panel_title { font-size: 1.4rem; }
  .zuppa_lms_login_pg_form_side   { padding: 36px 24px; }
}

/* ════════════════════════════════════
   RESPONSIVE — Mobile ≤ 640px
   Panel TOP → Form BOTTOM
════════════════════════════════════ */
@media (max-width: 640px) {
  .zuppa_lms_login_pg_root { flex-direction: column; }

  .zuppa_lms_login_pg_panel {
    width         : 100%;
    min-height    : 250px;
    border-radius : 0 0 30px 30px;
    animation     : lp_panel_top 0.75s cubic-bezier(0.22,1,0.36,1) both;
  }
  @keyframes lp_panel_top {
    from { transform: translateY(-100%); }
    to   { transform: translateY(0);     }
  }

  .zuppa_lms_login_pg_panel_body  { padding: 24px 18px 20px; gap: 10px; }
  .zuppa_lms_login_pg_drone_img   { width: 120px; }
  .zuppa_lms_login_pg_drone_shadow{ width: 60px; }
  .zuppa_lms_login_pg_panel_title { font-size: 1.25rem; }
  .zuppa_lms_login_pg_panel_sub   { font-size: 0.76rem; }

  .zuppa_lms_login_pg_form_side {
    padding   : 30px 20px 38px;
    animation : lp_form_up 0.75s cubic-bezier(0.22,1,0.36,1) both;
  }
  @keyframes lp_form_up {
    from { transform: translateY(80px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }

  .zuppa_lms_login_pg_form    { max-width: 100%; gap: 15px; }
  .zuppa_lms_login_pg_logo    { width: 66px; }
  .zuppa_lms_login_pg_input   { font-size: 0.87rem; }

  .zuppa_lms_login_pg_bubble_1 { width: 200px; height: 200px; top: -50px; left: -50px; }
  .zuppa_lms_login_pg_bubble_2 { width: 130px; height: 130px; }
  .zuppa_lms_login_pg_bubble_3 { width: 70px;  height: 70px;  }
}

/* ════════════════════════════════════
   RESPONSIVE — Small phone ≤ 380px
════════════════════════════════════ */
@media (max-width: 380px) {
  .zuppa_lms_login_pg_panel       { min-height: 210px; }
  .zuppa_lms_login_pg_drone_img   { width: 95px; }
  .zuppa_lms_login_pg_panel_title { font-size: 1.05rem; }
  .zuppa_lms_login_pg_form_side   { padding: 22px 14px 30px; }
  .zuppa_lms_login_pg_form_title  { font-size: 1.1rem; }
  .zuppa_lms_login_pg_logo        { width: 56px; }
  .zuppa_lms_login_pg_btn         { font-size: 0.85rem; padding: 12px; }
}`, "",{"version":3,"sources":["webpack://./src/Auth/Login.css"],"names":[],"mappings":";AAGA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,0CAA0C;AAC5C;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;;sCAEsC;AACtC;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB;;;;;GAKC;EACD,oEAAoE;AACtE;AACA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,wBAAwB,MAAM;AACvC;;AAEA,YAAY;AACZ;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,UAAU,EAAE,WAAW;EACvB,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,YAAY;EAC1B,gCAAgC;EAChC,+CAA+C;AACjD;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,aAAa,EAAE,UAAU;EACzB,kCAAkC;EAClC,+CAA+C;AACjD;AACA;EACE,UAAU,mBAAmB,KAAK,YAAY,EAAE;EAChD,UAAU,sBAAsB,EAAE,UAAU,IAAI;AAClD;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,iDAAiD;AACnD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;AAClD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wBAAwB;EACxB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,UAAU,4CAA4C,EAAE;EACxD,UAAU,2CAA2C,GAAG;AAC1D;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,6EAA6E;EAC7E,mBAAmB;EACnB,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,UAAU,oBAAoB,KAAK,aAAa,EAAE;EAClD,UAAU,sBAAsB,GAAG,YAAY,GAAG;AACpD;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;AAClD;AACA,6CAA6C,sBAAsB,EAAE;AACrE,6CAA6C,sBAAsB,EAAE;AACrE;EACE,cAAc,iCAAiC,EAAE,mBAAmB,IAAI;EACxE,cAAc,4BAA4B,QAAQ,qBAAqB,EAAE;AAC3E;;AAEA;;sCAEsC;AACtC;EACE,qBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;EACjC,yEAAyE;AAC3E;AACA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA,UAAU;AACV;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,QAAQ;AACR;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,oCAAoC;EACpC,6CAA6C;EAC7C,4BAA4B;EAC5B,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,uEAAuE;AACzE;AACA;EACE,cAAc;;AAEhB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;;EAEnB,+CAA+C;AACjD;AACA;EACE,uCAAuC;EACvC,uDAAuD;AACzD;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA,mCAAmC,uBAAuB,EAAE;;AAE5D,iBAAiB;AACjB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,sFAAsF;EACtF,sBAAsB;EACtB,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,gDAAgD;EAChD,8DAA8D;AAChE;AACA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;;AAEA;;sCAEsC;AACtC;EACE,kCAAkC,UAAU,EAAE;EAC9C,kCAAkC,iBAAiB,EAAE;EACrD,kCAAkC,kBAAkB,EAAE;AACxD;;AAEA;;;sCAGsC;AACtC;EACE,2BAA2B,sBAAsB,EAAE;;EAEnD;IACE,oBAAoB;IACpB,qBAAqB;IACrB,6BAA6B;IAC7B,mEAAmE;EACrE;EACA;IACE,OAAO,4BAA4B,EAAE;IACrC,OAAO,wBAAwB,MAAM;EACvC;;EAEA,kCAAkC,uBAAuB,EAAE,SAAS,EAAE;EACtE,kCAAkC,YAAY,EAAE;EAChD,kCAAkC,WAAW,EAAE;EAC/C,kCAAkC,kBAAkB,EAAE;EACtD,kCAAkC,kBAAkB,EAAE;;EAEtD;IACE,0BAA0B;IAC1B,6DAA6D;EAC/D;EACA;IACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;EAClD;;EAEA,8BAA8B,eAAe,EAAE,SAAS,EAAE;EAC1D,8BAA8B,WAAW,EAAE;EAC3C,8BAA8B,kBAAkB,EAAE;;EAElD,+BAA+B,YAAY,EAAE,aAAa,EAAE,UAAU,EAAE,WAAW,EAAE;EACrF,+BAA+B,YAAY,EAAE,aAAa,EAAE;EAC5D,+BAA+B,WAAW,GAAG,YAAY,GAAG;AAC9D;;AAEA;;sCAEsC;AACtC;EACE,kCAAkC,iBAAiB,EAAE;EACrD,kCAAkC,WAAW,EAAE;EAC/C,kCAAkC,kBAAkB,EAAE;EACtD,kCAAkC,uBAAuB,EAAE;EAC3D,kCAAkC,iBAAiB,EAAE;EACrD,kCAAkC,WAAW,EAAE;EAC/C,kCAAkC,kBAAkB,EAAE,aAAa,EAAE;AACvE","sourcesContent":["\r\n@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@600;800;900&family=Poppins:wght@300;400;500;600&display=swap');\r\n\r\n:root {\r\n  --lp-orange    : #ff6a00;\r\n  --lp-orange2   : #ff9533;\r\n  --lp-orange-gl : rgba(255, 106, 0, 0.30);\r\n  --lp-blue      : #0047cc;\r\n  --lp-blue2     : #002b88;\r\n  --lp-white     : #ffffff;\r\n  --lp-bg        : #f8faff;\r\n  --lp-border    : #dde4f7;\r\n  --lp-text      : #0d1b3e;\r\n  --lp-muted     : #6b7280;\r\n  --lp-err       : #ef4444;\r\n  --lp-r         : 13px;\r\n}\r\n\r\n/* ══ ROOT ══ */\r\n.zuppa_lms_login_pg_root {\r\n  display        : flex;\r\n  width          : 100%;\r\n  font-family    : 'Poppins', sans-serif;\r\n  overflow       : hidden;\r\n  background     : var(--lp-bg);\r\n  animation      : lp_root_in 0.4s ease both;\r\n}\r\n@keyframes lp_root_in {\r\n  from { opacity: 0; }\r\n  to   { opacity: 1; }\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   LEFT PANEL\r\n════════════════════════════════════ */\r\n.zuppa_lms_login_pg_panel {\r\n  position        : relative;\r\n  width           : 44%;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  overflow        : hidden;\r\n  background      : linear-gradient(150deg,\r\n    var(--lp-blue2) 0%,\r\n    var(--lp-blue)  55%,\r\n    #1a3fa8         78%,\r\n    var(--lp-orange) 130%\r\n  );\r\n  animation : lp_panel_slide 0.75s cubic-bezier(0.22, 1, 0.36, 1) both;\r\n}\r\n@keyframes lp_panel_slide {\r\n  from { transform: translateX(-100%); }\r\n  to   { transform: translateX(0);     }\r\n}\r\n\r\n/* Bubbles */\r\n.zuppa_lms_login_pg_bubble {\r\n  position      : absolute;\r\n  border-radius : 50%;\r\n  pointer-events: none;\r\n}\r\n.zuppa_lms_login_pg_bubble_1 {\r\n  width: 360px; height: 360px;\r\n  top: -90px; left: -90px;\r\n  background: rgba(255,255,255,0.06);\r\n  animation: lp_bubble 7s ease-in-out infinite;\r\n}\r\n.zuppa_lms_login_pg_bubble_2 {\r\n  width: 220px; height: 220px;\r\n  bottom: 40px; right: -50px;\r\n  background: rgba(255,106,0,0.14);\r\n  animation: lp_bubble 9s ease-in-out 2s infinite;\r\n}\r\n.zuppa_lms_login_pg_bubble_3 {\r\n  width: 120px; height: 120px;\r\n  bottom: 200px; left: 30px;\r\n  background: rgba(255,255,255,0.05);\r\n  animation: lp_bubble 6s ease-in-out 1s infinite;\r\n}\r\n@keyframes lp_bubble {\r\n  0%,100% { transform: scale(1);    opacity: 0.7; }\r\n  50%     { transform: scale(1.15); opacity: 1;   }\r\n}\r\n\r\n/* Panel body */\r\n.zuppa_lms_login_pg_panel_body {\r\n  position        : relative;\r\n  z-index         : 2;\r\n  display         : flex;\r\n  flex-direction  : column;\r\n  align-items     : center;\r\n  gap             : 16px;\r\n  padding         : 40px 28px;\r\n  text-align      : center;\r\n  animation       : lp_body_in 0.6s ease 0.65s both;\r\n}\r\n@keyframes lp_body_in {\r\n  from { opacity: 0; transform: translateY(22px); }\r\n  to   { opacity: 1; transform: translateY(0);    }\r\n}\r\n\r\n/* Drone */\r\n.zuppa_lms_login_pg_drone_wrap {\r\n  display        : flex;\r\n  flex-direction : column;\r\n  align-items    : center;\r\n}\r\n.zuppa_lms_login_pg_drone_img {\r\n  width          : min(62%, 240px);\r\n  height         : auto;\r\n  object-fit     : contain;\r\n  filter         : drop-shadow(0 18px 40px rgba(0,0,0,0.45));\r\n  animation      : lp_drone 3.8s ease-in-out infinite;\r\n}\r\n@keyframes lp_drone {\r\n  0%,100% { transform: translateY(0)     rotate(-1.5deg); }\r\n  50%     { transform: translateY(-18px) rotate(1.5deg);  }\r\n}\r\n.zuppa_lms_login_pg_drone_shadow {\r\n  width         : 80px;\r\n  height        : 14px;\r\n  background    : radial-gradient(ellipse, rgba(0,0,0,0.3) 0%, transparent 70%);\r\n  border-radius : 50%;\r\n  margin-top    : -2px;\r\n  animation     : lp_shadow 3.8s ease-in-out infinite;\r\n}\r\n@keyframes lp_shadow {\r\n  0%,100% { transform: scaleX(1);    opacity: 0.55; }\r\n  50%     { transform: scaleX(0.5);  opacity: 0.2;  }\r\n}\r\n\r\n.zuppa_lms_login_pg_panel_title {\r\n  font-family   : 'Orbitron', sans-serif;\r\n  font-size     : clamp(1.3rem, 2.5vw, 2rem);\r\n  font-weight   : 900;\r\n  color         : var(--lp-white);\r\n  margin        : 0;\r\n  letter-spacing: 0.05em;\r\n  text-shadow   : 0 2px 18px rgba(0,0,0,0.3);\r\n}\r\n.zuppa_lms_login_pg_panel_sub {\r\n  font-size  : clamp(0.75rem, 1.2vw, 0.88rem);\r\n  color      : rgba(255,255,255,0.84);\r\n  line-height: 1.7;\r\n  margin     : -4px 0 0;\r\n  max-width  : 220px;\r\n}\r\n\r\n/* Dots */\r\n.zuppa_lms_login_pg_dots {\r\n  display    : flex;\r\n  gap        : 9px;\r\n  margin-top : 4px;\r\n}\r\n.zuppa_lms_login_pg_dots span {\r\n  width         : 9px;\r\n  height        : 9px;\r\n  border-radius : 50%;\r\n  background    : rgba(255,255,255,0.35);\r\n  animation     : lp_dot 1.5s ease-in-out infinite;\r\n}\r\n.zuppa_lms_login_pg_dots span:nth-child(2) { animation-delay: 0.22s; }\r\n.zuppa_lms_login_pg_dots span:nth-child(3) { animation-delay: 0.44s; }\r\n@keyframes lp_dot {\r\n  0%,80%,100% { background: rgba(255,255,255,0.3); transform: scale(1);   }\r\n  40%         { background: var(--lp-orange);       transform: scale(1.4); }\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   RIGHT — FORM SIDE\r\n════════════════════════════════════ */\r\n.zuppa_lms_login_pg_form_side {\r\n  flex            : 1;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  padding         : 40px 36px;\r\n  background      : var(--lp-white);\r\n  animation       : lp_form_slide 0.75s cubic-bezier(0.22, 1, 0.36, 1) both;\r\n}\r\n@keyframes lp_form_slide {\r\n  from { transform: translateX(100%); opacity: 0; }\r\n  to   { transform: translateX(0);    opacity: 1; }\r\n}\r\n\r\n.zuppa_lms_login_pg_form {\r\n  width          : 100%;\r\n  max-width      : 400px;\r\n  display        : flex;\r\n  flex-direction : column;\r\n  align-items    : center;\r\n  gap            : 18px;\r\n  animation      : lp_body_in 0.55s ease 0.7s both;\r\n}\r\n\r\n/* Logo */\r\n.zuppa_lms_login_pg_logo {\r\n  width      : 84px;\r\n  height     : auto;\r\n  object-fit : contain;\r\n  filter     : drop-shadow(0 4px 14px rgba(255,106,0,0.22));\r\n}\r\n\r\n/* Title */\r\n.zuppa_lms_login_pg_form_title {\r\n  font-family    : 'Orbitron', sans-serif;\r\n  font-size      : clamp(1.3rem, 2.5vw, 1.75rem);\r\n  font-weight    : 800;\r\n  color          : var(--lp-blue);\r\n  margin         : 0;\r\n  text-align     : center;\r\n  letter-spacing : 0.02em;\r\n}\r\n.zuppa_lms_login_pg_form_title span {\r\n  color: var(--lp-orange);\r\n}\r\n\r\n/* Sub */\r\n.zuppa_lms_login_pg_form_sub {\r\n  font-size   : 0.82rem;\r\n  color       : var(--lp-muted);\r\n  margin      : -10px 0 4px;\r\n  text-align  : center;\r\n}\r\n\r\n/* ── Field wrapper ── */\r\n.zuppa_lms_login_pg_field {\r\n  width          : 100%;\r\n  display        : flex;\r\n  flex-direction : column;\r\n  gap            : 0;\r\n}\r\n\r\n/* Input + icon row */\r\n.zuppa_lms_login_pg_input_wrap {\r\n  position        : relative;\r\n  width           : 100%;\r\n  display         : flex;\r\n  align-items     : center;\r\n}\r\n\r\n/* Left icon */\r\n.zuppa_lms_login_pg_field_icon {\r\n  position        : absolute;\r\n  left            : 14px;\r\n  top             : 40%;\r\n  transform       : translateY(-50%);\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  pointer-events  : none;\r\n  z-index         : 3;\r\n  line-height     : 1;\r\n}\r\n\r\n/* Input */\r\n.zuppa_lms_login_pg_input {\r\n  width          : 100%;\r\n  padding        : 14px 50px 10px 46px;\r\n  border         : 1.8px solid var(--lp-border);\r\n  border-radius  : var(--lp-r);\r\n  font-size      : 0.9rem;\r\n  font-family    : 'Poppins', sans-serif;\r\n  color          : var(--lp-text);\r\n  background     : #f7f9ff;\r\n  outline        : none;\r\n  box-sizing     : border-box;\r\n  transition     : border-color 0.25s, box-shadow 0.25s, background 0.25s;\r\n}\r\n.zuppa_lms_login_pg_input::placeholder {\r\n  color: #aab4cc;\r\n\r\n}\r\n.zuppa_lms_login_pg_input:focus {\r\n  border-color : var(--lp-orange);\r\n  background   : #fff;\r\n  \r\n  box-shadow   : 0 0 0 3.5px rgba(255,106,0,0.13);\r\n}\r\n.zuppa_lms_login_pg_input_bad {\r\n  border-color : var(--lp-err) !important;\r\n  box-shadow   : 0 0 0 3px rgba(239,68,68,0.1) !important;\r\n}\r\n\r\n/* Eye button — right side */\r\n.zuppa_lms_login_pg_eye {\r\n  position        : absolute;\r\n  right           : 13px;\r\n  top             : 50%;\r\n  transform       : translateY(-50%);\r\n  background      : none;\r\n  border          : none;\r\n  cursor          : pointer;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  padding         : 0;\r\n  z-index         : 3;\r\n  line-height     : 1;\r\n  transition      : transform 0.2s, opacity 0.2s;\r\n}\r\n.zuppa_lms_login_pg_eye:hover {\r\n  transform : translateY(-50%) scale(1.2);\r\n  opacity   : 0.8;\r\n}\r\n\r\n/* Error message */\r\n.zuppa_lms_login_pg_err {\r\n  font-size   : 0.72rem;\r\n  color       : var(--lp-err);\r\n  padding-left: 4px;\r\n  margin      : 5px 0 0;\r\n}\r\n\r\n/* Forgot */\r\n.zuppa_lms_login_pg_forgot {\r\n  align-self      : flex-end;\r\n  font-size       : 0.78rem;\r\n  color           : var(--lp-blue);\r\n  cursor          : pointer;\r\n  text-decoration : underline;\r\n  font-weight     : 600;\r\n  margin-top      : -4px;\r\n  transition      : color 0.2s;\r\n}\r\n.zuppa_lms_login_pg_forgot:hover { color: var(--lp-orange); }\r\n\r\n/* Login button */\r\n.zuppa_lms_login_pg_btn {\r\n  width           : 100%;\r\n  padding         : 14px;\r\n  margin-top      : 4px;\r\n  border          : none;\r\n  border-radius   : var(--lp-r);\r\n  background      : linear-gradient(120deg, var(--lp-orange) 0%, var(--lp-orange2) 100%);\r\n  color           : #fff;\r\n  font-family     : 'Orbitron', sans-serif;\r\n  font-size       : 0.95rem;\r\n  font-weight     : 700;\r\n  letter-spacing  : 0.1em;\r\n  cursor          : pointer;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  gap             : 10px;\r\n  box-shadow      : 0 7px 22px var(--lp-orange-gl);\r\n  transition      : transform 0.2s, box-shadow 0.2s, filter 0.2s;\r\n}\r\n.zuppa_lms_login_pg_btn:hover {\r\n  transform  : translateY(-2px);\r\n  box-shadow : 0 12px 32px var(--lp-orange-gl);\r\n  filter     : brightness(1.07);\r\n}\r\n.zuppa_lms_login_pg_btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   RESPONSIVE — Tablet ≤ 860px\r\n════════════════════════════════════ */\r\n@media (max-width: 860px) {\r\n  .zuppa_lms_login_pg_panel       { width: 42%; }\r\n  .zuppa_lms_login_pg_panel_title { font-size: 1.4rem; }\r\n  .zuppa_lms_login_pg_form_side   { padding: 36px 24px; }\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   RESPONSIVE — Mobile ≤ 640px\r\n   Panel TOP → Form BOTTOM\r\n════════════════════════════════════ */\r\n@media (max-width: 640px) {\r\n  .zuppa_lms_login_pg_root { flex-direction: column; }\r\n\r\n  .zuppa_lms_login_pg_panel {\r\n    width         : 100%;\r\n    min-height    : 250px;\r\n    border-radius : 0 0 30px 30px;\r\n    animation     : lp_panel_top 0.75s cubic-bezier(0.22,1,0.36,1) both;\r\n  }\r\n  @keyframes lp_panel_top {\r\n    from { transform: translateY(-100%); }\r\n    to   { transform: translateY(0);     }\r\n  }\r\n\r\n  .zuppa_lms_login_pg_panel_body  { padding: 24px 18px 20px; gap: 10px; }\r\n  .zuppa_lms_login_pg_drone_img   { width: 120px; }\r\n  .zuppa_lms_login_pg_drone_shadow{ width: 60px; }\r\n  .zuppa_lms_login_pg_panel_title { font-size: 1.25rem; }\r\n  .zuppa_lms_login_pg_panel_sub   { font-size: 0.76rem; }\r\n\r\n  .zuppa_lms_login_pg_form_side {\r\n    padding   : 30px 20px 38px;\r\n    animation : lp_form_up 0.75s cubic-bezier(0.22,1,0.36,1) both;\r\n  }\r\n  @keyframes lp_form_up {\r\n    from { transform: translateY(80px); opacity: 0; }\r\n    to   { transform: translateY(0);    opacity: 1; }\r\n  }\r\n\r\n  .zuppa_lms_login_pg_form    { max-width: 100%; gap: 15px; }\r\n  .zuppa_lms_login_pg_logo    { width: 66px; }\r\n  .zuppa_lms_login_pg_input   { font-size: 0.87rem; }\r\n\r\n  .zuppa_lms_login_pg_bubble_1 { width: 200px; height: 200px; top: -50px; left: -50px; }\r\n  .zuppa_lms_login_pg_bubble_2 { width: 130px; height: 130px; }\r\n  .zuppa_lms_login_pg_bubble_3 { width: 70px;  height: 70px;  }\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   RESPONSIVE — Small phone ≤ 380px\r\n════════════════════════════════════ */\r\n@media (max-width: 380px) {\r\n  .zuppa_lms_login_pg_panel       { min-height: 210px; }\r\n  .zuppa_lms_login_pg_drone_img   { width: 95px; }\r\n  .zuppa_lms_login_pg_panel_title { font-size: 1.05rem; }\r\n  .zuppa_lms_login_pg_form_side   { padding: 22px 14px 30px; }\r\n  .zuppa_lms_login_pg_form_title  { font-size: 1.1rem; }\r\n  .zuppa_lms_login_pg_logo        { width: 56px; }\r\n  .zuppa_lms_login_pg_btn         { font-size: 0.85rem; padding: 12px; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
